export default "/assets/0ca2e7ebc8fbf646.svg"